import {
  GET_X10_DEVICES,
  GET_X10_DEVICES_ERROR,
  GET_X10_DEVICES_SUCCESS,
  IGetX10DevicesAction,
  IGetX10DevicesErrorAction,
  IGetX10DevicesSuccessAction,
  IX10DevicePage,
  IX10DeviceQuery
} from "./types";

/** Changes the list query (merged into the current one) and fetches that page. */
export const getX10Devices = (query: Partial<IX10DeviceQuery> = {}): IGetX10DevicesAction => ({
  type: GET_X10_DEVICES,
  payload: query
});

export const getX10DevicesSuccess = (page: IX10DevicePage): IGetX10DevicesSuccessAction => ({
  type: GET_X10_DEVICES_SUCCESS,
  payload: page
});

export const getX10DevicesError = (): IGetX10DevicesErrorAction => ({
  type: GET_X10_DEVICES_ERROR
});
